<ng-container>
  <div class="ior-contact-container pr-0 pl-0">
    <span class="ior-contact-container__header">
      {{ "COMPANY.IOR.HEADER" | translate }}

      <span class="d-lg-none">
        <app-hint-tooltip-icon [hint]="'COMPANY.IOR.DESCRIPTION' | translate"></app-hint-tooltip-icon>
      </span>
    </span>
    <div class="d-flex" [formGroup]="formGroup">
      <div class="ior-contact-container-form pr-0 pl-0" [ngClass]="{ 'col-12 col-lg-8': isShowDescription, 'col-12': !isShowDescription }">
        <!-- Checkbox: Use my existing user information as IOR -->
        <div class="custom-control custom-checkbox ior-contact-container-form__checkbox">
          <input type="checkbox" [formControl]="formGroup.get('isImporterOfRecord')" class="custom-control-input" id="isImporterOfRecord" />
          <label class="custom-control-label" for="isImporterOfRecord">
            {{ "COMPANY.IOR.USE_EXISTING_USER" | translate }}
            <app-hint-tooltip-icon
              *ngIf="isPoaSigned"
              [hint]="'COMPANY.IOR.USE_EXISTING_LOCKED_POA_HINT' | translate"
            ></app-hint-tooltip-icon>
          </label>
        </div>

        <!-- First Name & Last Name row -->
        <div class="row" formGroupName="importerOfRecordContactInformation">
          <div class="col-12 col-lg-6" id="control-iorFirstName">
            <app-control-wrapper [errors]="errors.firstName" [control]="iorFormGroup?.get('firstName')">
              <label for="iorFirstName" control-label>
                {{ "LABELS.FIRST_NAME" | translate }}
              </label>
              <input
                type="text"
                formControlName="firstName"
                class="form-control"
                id="iorFirstName"
                name="iorFirstName"
                autocomplete="chrome-off"
                [placeholder]="'LABELS.FIRST_NAME' | translate"
                [dropSpecialCharacters]="false"
                [patterns]="CUSTOM_MASK"
                [mask]="'N{50}'"
                [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH'"
                [maxMaskLength]="50"
                control-wrapper
                (blur)="trimField('firstName')"
              />
            </app-control-wrapper>
          </div>
          <div class="col-12 col-lg-6" id="control-iorLastName">
            <app-control-wrapper [errors]="errors.lastName" [control]="iorFormGroup?.get('lastName')">
              <label for="iorLastName" control-label>
                {{ "LABELS.LAST_NAME" | translate }}
              </label>
              <input
                type="text"
                formControlName="lastName"
                class="form-control"
                id="iorLastName"
                name="iorLastName"
                autocomplete="chrome-off"
                [placeholder]="'LABELS.LAST_NAME' | translate"
                [dropSpecialCharacters]="false"
                [patterns]="CUSTOM_MASK"
                [mask]="'N{50}'"
                [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH'"
                [maxMaskLength]="50"
                control-wrapper
                (blur)="trimField('lastName')"
              />
            </app-control-wrapper>
          </div>
        </div>

        <!-- Phone Number -->
        <div id="control-iorPhoneNumber">
          <input-phone
            [fc]="iorFormGroup?.get('phoneNumber')"
            [errors]="errors.phoneNumber"
            [label]="'COMPANY.IOR.MOBILE_NUMBER'"
            [id]="'iorPhoneNumber'"
            [autocomplete]="'chrome-off'"
          ></input-phone>
        </div>

        <!-- Email Address -->
        <div formGroupName="importerOfRecordContactInformation" id="control-iorEmailAddress">
          <app-control-wrapper [errors]="errors.emailAddress" [control]="iorFormGroup?.get('emailAddress')">
            <label for="iorEmailAddress" control-label>
              {{ "LABELS.EMAIL_ADDRESS" | translate }}
              <app-hint-tooltip-icon *ngIf="isPoaSigned" [hint]="'COMPANY.IOR.EMAIL_LOCKED_POA_HINT' | translate"></app-hint-tooltip-icon>
            </label>
            <input
              type="email"
              formControlName="emailAddress"
              class="form-control"
              id="iorEmailAddress"
              name="iorEmailAddress"
              autocomplete="chrome-off"
              [placeholder]="'LABELS.EMAIL_ADDRESS' | translate"
              control-wrapper
              (blur)="onEmailBlur()"
            />
          </app-control-wrapper>
        </div>
      </div>
      <div class="d-none d-lg-block" [ngClass]="{ 'col-4': isShowDescription }" *ngIf="isShowDescription">
        <div class="ior-contact-container-description">
          <span>{{ "COMPANY.IOR.DESCRIPTION" | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Phone Number Modal -->
  <div class="overlay-modal" *ngIf="isPhoneModalOpen" (click)="onPhoneModalClose()">
    <div class="phone-modal" (click)="$event.stopPropagation()">
      <div class="phone-modal__title">
        {{ "COMPANY.IOR.PHONE_MODAL_TITLE" | translate }}
      </div>
      <div class="phone-modal__desc">
        {{ "COMPANY.IOR.PHONE_MODAL_DESCRIPTION" | translate }}
      </div>
      <div class="phone-modal__field">
        <input-phone
          [fc]="phoneFormControl"
          [errors]="errors.phoneNumber"
          [label]="'LABELS.MOBILE_NUMBER'"
          [id]="'iorPhoneModal'"
        ></input-phone>
      </div>
      <div class="phone-modal__actions">
        <button type="button" class="btn btn-decline" (click)="onPhoneModalClose()">
          {{ "BUTTON.CANCEL" | translate }}
        </button>
        <button type="button" class="btn btn-accept" [disabled]="isPhoneSaving || !isPhoneValid()" (click)="onPhoneModalSave()">
          <span *ngIf="isPhoneSaving" class="spinner-border spinner-border-sm mr-1"></span>
          {{ "BUTTON.SAVE" | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- IOR Match Confirmation Modal (#13004) -->
  <app-ior-match-confirm-modal
    [open]="isMatchConfirmOpen"
    (accept)="onIorMatchAccept()"
    (decline)="onIorMatchDecline()"
  ></app-ior-match-confirm-modal>
</ng-container>
